import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Breadcrumb, Stack, StackItem } from "@fluentui/react";
import { Button, Divider, Text, Body1Strong, Title3, Caption1, FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ArrowClockwise20Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { useNavigate } from "react-router-dom";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { GlobalContext } from "../../hooks/globalContext";
import { primaryIcon, buttonContent, heightResponsive, DynamicBoxingCSS, parentHome, SubSectionResponsive, secondaryIcon, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { DataTable } from "../../components/data_table/data_table.component";
import { AdministrationPages } from "../../components/side_menu/InlineSidenav";

export const Uploader = () => {

    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isRefresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(true);
    const [final_data, set_final_data]: any = useState([]);

    const [uploadPath, setuploadPath] = useState('');

    const navigate = useNavigate();
    const { permissions } = usePermissionStore();
    const contextValue: any = useContext(GlobalContext);
    const handle = useFullScreenHandle();
    const [tableData, setTableData] = useState<any[]>([]);
    const [error, setError] = useState('');

    useEffect(() => {
        const envData = process.env.REACT_APP_S3_FOLDER_LIST;
        try {
            if (envData) {
                set_final_data(JSON.parse(envData));
            }
        } catch (error) {
            console.error("Error parsing REACT_APP_S3_FOLDER_LIST:", error);
        }
    }, [isRefresh]);

    // Handle File Selection

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setLoading(true); }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
    };
    // overflow set contents code ends here

    const navigateToUpload = (path: string) => {
        navigate(`/manage/administration/upload/fileupload`);
    }
    //data table column name code starts here
    var columns = [
        { key: "folder_name", label: <Body1Strong>Folder Name</Body1Strong> },
        { key: "path_name", label: <Body1Strong>Path</Body1Strong> },
    ];
    //data table column name code ends here
    var tempTableData: any = [];
    useEffect(() => {
        // data table values append code starts here
        console.log("final_data=", final_data);

        final_data !== undefined && final_data !== null
            ? final_data.map((val: any, i: any) => {
                {
                    permissions.includes("all") || permissions.includes("administrationLog_ReadandExport") ?
                        tempTableData.push({
                            id: val.Key,
                            checkbox: "hide",
                            folder_name: {
                                label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => {
                                    navigate("/manage/administration/upload/fileupload");
                                    localStorage.setItem('folderPath', val.path);
                                    contextValue.setSelectedRowDetails({
                                        ...contextValue.selectedRowDetails,
                                        name: val.path
                                    });
                                }}> {val.folder} </Button>, icon: "", id: `${i}`
                            },
                            path_name: { label: <Caption1 > {val.path} </Caption1>, icon: "", id: `${i}` },
                            // date: { label: <Caption1>{convertDateToHumanReadableFormat(val.LastModified)}</Caption1> },
                            // // date_timezoned: { label: <Button shape="circular" style={buttonContent} appearance="transparent" size="small" }> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
                            // size: { label: <Caption1> {(val.Size / 1024 / 1024).toFixed(2)} MB </Caption1> },
                        })
                        :
                        tempTableData.push({
                            id: val.ID,
                            checkbox: "hide",
                            folder_name: { label: <Caption1> {val.folder} </Caption1>, status: "" },
                            path_name: { label: <Caption1> {val.path} </Caption1>, status: "" },
                            // date: { label: <Caption1>{val.LastModified}</Caption1> },
                            // // date_timezoned: { label: <Button shape="circular" style={buttonContent} appearance="transparent" size="small" }> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
                            // size: { label: <Caption1> {val.Size} </Caption1> },
                        })
                }
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                            {name: "Manage", link: "/home" },
                                            {name:"Administration", link:"/manage/administration/role"},
                                            {name:"Upload", link:"#"},
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AdministrationPages("Upload")} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                {<Divider />}
                                            </StackItem>
                                        </Stack>
                                        <Stack style={parentHome}>
                                            <Stack><StackItem></StackItem></Stack>
                                            <Stack><StackItem></StackItem></Stack>
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                    </StackItem>
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};